import inputIcon from '../themes/high-contrast/extensions/inputIcon.png';
import outputIcon from '../themes/high-contrast/extensions/outputIcon.png';
import displayIcon from '../themes/high-contrast/extensions/displayIcon.png';
import motorIcon from '../themes/high-contrast/extensions/motorIcon.png';
import motionIcon from '../themes/high-contrast/extensions/motionIcon.png';
import lineIcon from '../themes/high-contrast/extensions/xlineIcon.png';
import proIcon from '../themes/high-contrast/extensions/xlineproIcon.png';
import eventIcon from '../themes/high-contrast/extensions/eventIcon.png';

export const xline1_2 = () => `
    <category name="%{BKY_XROBO_INPUT}" id="xline12_input" colour="#42CCFF" secondaryColour="#22C3FF" iconURI="${inputIcon}">
  <block type="xline_input_contactsensor">
   <value name="ARG1">
                <shadow type="math_number">
                    <field name="text">IN2</field>
                </shadow>
    </value></block>
  <block type="xline_input_irsensor1"></block>
  <block type="xline_input_irsensor2">
    <value name="ARG2">
                <shadow type="math_number">
                    <field name="NUM">512</field>
                </shadow>
    </value>
  </block>
  <block type="xline_input_irsensor3"></block>
  <block type="xline_input_sensor_read"></block>
  <block type="xline_input_wait"></block>
</category>

  <category name="%{BKY_XROBO_OUTPUT}" id="xrobo_xline_output" colour="#7ED321" secondaryColour="#71BE1E" iconURI="${outputIcon}">
    <block type="xline_output_led"></block>
    <block type="xline_output_buzzer"></block>
    <block type="xline_output_melody1"></block>
    <block type="xline_output_melody2">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">262</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">200</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">250</field>
            </shadow>
        </value>
    </block>
    <block type="xline_output_pitch1">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">1</field>
            </shadow>
        </value>
    </block>
    <block type="xline_output_pitch2"></block>
    <block type="xline_output_servo1"></block>
    <block type="xline_output_servo2">
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">262</field>
            </shadow>
        </value>
    </block>
    <block type="xline_output_slow1"></block>
    <block type="xline_output_slow2">
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
    </block>
    <block type="xline_output_servo_value">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
    </block>
  </category>

  <category name="%{BKY_XROBO_MOTOR}"  id="xrobo_xline_motor" colour="#FFD740" secondaryColour="#FFD020" iconURI="${motorIcon}">
    <block type="xline_motor_1">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">500</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motor_2"></block>
    <block type="xline_motor_speed1">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motor_speed2"></block>
  </category>

  <category name="XLINE"  id="xrobo_xline" colour="#A6D200" secondaryColour="#95BD00" iconURI="${lineIcon}">
    <block type="xline_xl_go">
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_linedelay">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">100</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_l_turn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_r_turn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_turn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">-30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_uturn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">-30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_findline">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_xl_endline">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
  </category>

  <category name="MOTION"  id="xrobo_motor" colour="#522E92" secondaryColour="#4A2983" iconURI="${motionIcon}">
    <block type="xline_motion_servo"></block>
    <block type="xline_motion_get_set">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">1000</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_get">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">1</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">300</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_open_set">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_open">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_down_set">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">1000</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_down">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">500</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_up_set">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">90</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_motion_up">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
  </category>

  <category name="XLINE_PRO"  id="xrobo_motor" colour="#0842EB" secondaryColour="#073BDC" iconURI="${proIcon}">
    <block type="xline_pro_hdriver">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">46</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">35</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG6">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_ldriver">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">25</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">17</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">7</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">3</field>
            </shadow>
        </value>
        <value name="ARG6">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_go1">
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_go2">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG6">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_linedelay">
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">100</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_turn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_uturn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_exline">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_exturn">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">50</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_findline">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_endline">
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">30</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">100</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_m_get1">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">500</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_m_get2">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG6">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_fsensor">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">500</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_s_get1">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG2">
            <shadow type="math_number">
                <field name="NUM">10</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_s_get2">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG3">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG4">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_s_get3">
        <value name="ARG1">
            <shadow type="math_number">
                <field name="NUM">5</field>
            </shadow>
        </value>
        <value name="ARG5">
            <shadow type="math_number">
                <field name="NUM">20</field>
            </shadow>
        </value>
        <value name="ARG6">
            <shadow type="math_number">
                <field name="NUM">0</field>
            </shadow>
        </value>
    </block>
    <block type="xline_pro_line_color"></block>
    <block type="xline_pro_wait"></block>
  </category>

  <category name="%{BKY_XROBO_EVENT}" id="xrobo_event" colour="#FFBF00" secondaryColour="#E6AC00" iconURI="${eventIcon}">
    <block type="xline_start"></block>
    <block type="xrobo_reset_timer"></block>
    <block type="xrobo_get_seconds"></block>
    <block type="xrobo_get_milliseconds"></block>
  </category>
`;
